import DraggableThumb from '../draggable_thumb_controller';

export default class extends DraggableThumb {
  static targets = ['favoriteButton'];

  static values = {
    hex: String,
  };

  createGhostElement() {
    const element = document.createElement('div');
    element.style.backgroundColor = this.hexValue;

    return element;
  }

  addItem(itemProps) {
    itemProps['kind'] = 'swatch';
    window.ed.featureActionsService.add('swatch_added_to_canvas');
    itemProps['hex'] = this.hexValue;

    return super.addItem(itemProps);
  }

  unfavorited() {
    this.dispatch('unfavorited');
  }
}
